// DONOT TOUCH / EDIT/ SEE / TASTE/ WHATEVER
window.addEventListener("DOMContentLoaded", (event) => {
  let websitePath = location.pathname;
  fetch(`${window.location.origin}/browsing_context_suggestions.json`)
    .then((response) => response.json())
    .then((result) => {
      if (result.detected_values.country.handle !== Shopify.country) {
        //       //changeLocal(result.detected_values.country.handle);
        if (result.detected_values.country.handle == "US") {
          window.location.href =
            "https://us.thesummerhouse.in" +
            websitePath;
        } else if (result.detected_values.country.handle == "IN") {
          window.location.href =
            "https://thesummerhouse.in" +
            websitePath;
        } else if (
          result.detected_values.country.handle != "IN" &&
          result.detected_values.country.handle != "US"
        ) {
          if (location.host.split(".")[0] != "int") {
            window.location.href =
              "https://int.thesummerhouse.in" +
              websitePath;
          }
        }
      }
      if (result.detected_values.country.handle == "IN") {
        document.cookie =
          "CustomCurrency=INR; expires=Fri, 31 Dec 9999 23:59:59 GMT";
      } else {
        document.cookie =
          "CustomCurrency=USD; expires=Fri, 31 Dec 9999 23:59:59 GMT";
      }
    })
    .catch((error) => console.log("error", error));
  // function changeLocal(country) {
  //   fetch("https://thesummerhouse.in/localization", {
  //     headers: {
  //       accept:
  //         "text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7",
  //       "accept-language": "en-GB,en-US;q=0.9,en;q=0.8",
  //       "cache-control": "max-age=0",
  //       "content-type":
  //         "multipart/form-data; boundary=----WebKitFormBoundaryTDCR7YAGl47PcGld",
  //       "sec-ch-ua":
  //         '"Google Chrome";v="111", "Not(A:Brand";v="8", "Chromium";v="111"',
  //       "sec-ch-ua-mobile": "?0",
  //       "sec-ch-ua-platform": '"macOS"',
  //       "sec-fetch-dest": "document",
  //       "sec-fetch-mode": "navigate",
  //       "sec-fetch-site": "same-origin",
  //       "sec-fetch-user": "?1",
  //       "upgrade-insecure-requests": "1",
  //     },
  //     referrer: "https://thesummerhouse.in/products/d246-kiki-dress",
  //     referrerPolicy: "strict-origin-when-cross-origin",
  //     body:
  //       '------WebKitFormBoundaryTDCR7YAGl47PcGld\r\nContent-Disposition: form-data; name="form_type"\r\n\r\nlocalization\r\n------WebKitFormBoundaryTDCR7YAGl47PcGld\r\nContent-Disposition: form-data; name="utf8"\r\n\r\n✓\r\n------WebKitFormBoundaryTDCR7YAGl47PcGld\r\nContent-Disposition: form-data; name="_method"\r\n\r\nput\r\n------WebKitFormBoundaryTDCR7YAGl47PcGld\r\nContent-Disposition: form-data; name="return_to"\r\n\r\n/products/d246-kiki-dress\r\n------WebKitFormBoundaryTDCR7YAGl47PcGld\r\nContent-Disposition: form-data; name="country_code"\r\n\r\n' +
  //       country +
  //       "\r\n------WebKitFormBoundaryTDCR7YAGl47PcGld--\r\n",
  //     method: "POST",
  //     mode: "cors",
  //     credentials: "include",
  //   }).finally(() => {
  //     window.location.reload();
  //   });
  // }
  function changehrefs() {
    document.querySelectorAll("[href]").forEach((x) => {
      if (x.getAttribute("href").includes("thesummerhouse.in")) {
        if (
          x.getAttribute("href").split("thesummerhouse.in")[0] === "https://"
        ) {
          x.setAttribute(
            "href",
            x.getAttribute("href").split("thesummerhouse.in")[1]
          );
        }
      }
    });
    //x.setAttribute('href',`${window.location.origin}/`);
  }
  function getNewConversionRates() {
    //const response = await fetch('https://thesummerhouse.in/services/javascripts/currencies.js');
    // const responseText = await response.text();
    //const conversionRates =  JSON.parse(responseText.substring(responseText.search("rates: {")+7,responseText.search("},")+1));
    return fetch(
      `${window.location.origin}/services/javascripts/currencies.js`,
      {
        method: "GET",
        redirect: "follow",
      }
    )
      .then((response) => response.text())
      .then((result) => {
        const conversionRates = JSON.parse(
          result.substring(
            result.search("rates: {") + 7,
            result.search("},") + 1
          )
        );
        localStorage.setItem(
          "conversionRates",
          JSON.stringify(conversionRates)
        );
        return "ok";
      })
      .catch((error) => console.log("error", error));
    // Save the conversion rates into local storage
    // localStorage.setItem('conversionRates', JSON.stringify(conversionRates));
  }
  getNewConversionRates();
  changehrefs();

  // DONOT TOUCH / EDIT/ SEE / TASTE/ WHATEVER
});
